import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import AppShell from './AppShell';
import './PaymentResult.css';

export default function PaymentCancelled() {
    const location = useLocation();
    const navigate = useNavigate();
    const orderCode = new URLSearchParams(location.search).get('orderCode');

    return (
        <AppShell title="Thanh toán" back onBack={() => navigate('/')} tabbar={false} head={false}>
            <div className="shell">
                <div className="result-wrap">
                    <div className="result-icon bad"><i className="fa-solid fa-xmark" /></div>
                    <h1 className="result-title">Thanh toán chưa hoàn tất</h1>
                    {orderCode && <div className="result-code">#{orderCode}</div>}
                    <p className="result-text">
                        Giao dịch đã bị huỷ hoặc chưa hoàn tất. Đơn của bạn vẫn được giữ chỗ — bạn có thể mở lại mã VietQR
                        trong mục “Đơn của tôi” để thanh toán lại.
                    </p>
                    <div className="result-actions">
                        <Link to="/my-orders" className="btn btn-primary btn-block">Thanh toán lại</Link>
                        <Link to="/menu" className="btn btn-quiet btn-block">Tiếp tục chọn bánh</Link>
                    </div>
                </div>
            </div>
        </AppShell>
    );
}
